export const DEBOUNCE_TIME = 500

export const ZIP_CODE_CHAR_LENGTH = 6
export const INN_CHAR_LENGTH = 9
export const SOLE_LEGAL_CHAR_LENGTH = 12
export const COMPANY_LEGAL_CHAR_LENGTH = 10
